import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import moment from "moment";
import { VueBase } from "../Controls/VueBase";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "../Controls/EventBus";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../Controls/EventConstants";

@Component
export default class ListeSocietesComponent extends VueBase {
	public isDataReady = false;
	public isModified = false;
	public societes: SocieteDto[] = [];

	public activated(): void {
    	this.fetchData();
	}

	public deactivated(): void {
    	this.isDataReady = false;
    	this.isModified = false;
	}

	public modify(): void {
    	this.isModified = true;
	}

	public getDateExercice(annee: number, mois: number): string {
    	return moment(new Date(annee, mois - 1, 1)).format("MMMM YYYY").toString();
	}

	public validate(): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Attention, le changement de statut de société va fermer tous les onglets ouverts, et les saisies en cours éventuelles seront perdues. Souhaitez-vous vraiment continuer ?",
    		callBackYes: () => {
    			ServicesFactoryInstance.SocieteService.updateSocietesStatut(this.societes, () => {
    				window.location.reload();
    			});
    		},
    		callBackNo: () => {
    			this.fetchData();
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public cancel(): void {
    	this.fetchData();
	}

	private fetchData(): void {
    	ServicesFactoryInstance.SocieteService.getAllSocietes(data => {
    		this.societes = data;
    		this.isDataReady = true;
    		this.isModified = false;
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/listeSocietes/listeSocietes.ts